import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Button, Box, Container, Paper, CircularProgress, Link } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { COLOR_VALUES, buttonStylesByNames } from '../../utils/style';
import { APP_BUTTON_VARIANT, APP_BUTTON_MARGIN, APP_SPORT_MARGIN } from '../config';
import CloseIcon from '@mui/icons-material/Close';
import { useWallet, useConnection } from '@solana/wallet-adapter-react';
import { useAppStore } from '../../store/AppStore';
import decimalToAmerican from '../../utils/oddsConversion';
import { useEffect, useState } from 'react';
import { usePendingBetsContext } from '../../context/PendingBetsContext';
import { PublicKey, Transaction, TransactionInstruction } from '@solana/web3.js';
import { add, differenceInSeconds, fromUnixTime, isPast, subSeconds } from 'date-fns';
import axios from 'axios';
var solanaWeb3 = require("@solana/web3.js");

var programID = new solanaWeb3.PublicKey("9uReBEtnYGYf1oUe4KGSt6kQhsqGE74i17NzRNEDLutn");
var pool = new solanaWeb3.PublicKey("5HFVYfkjEh2XT9ZxVeVSYs5hc3rHYNjc6KPGvcRQWymv");
var tokenProgram = new solanaWeb3.PublicKey("TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb");
var mint = process.env.REACT_APP_WALLET_ADAPTER_NETWORK == 'dev' ? 
  new solanaWeb3.PublicKey("3zPjW4EMwJzd6yjriNk66X88aJqjgKcXWL8Cfb2Ydyfm") : 
  new solanaWeb3.PublicKey("AKEWE7Bgh87GPp171b4cJPSSZfmZwQ3KaqYqXoKLNAEE");;
var pda = new solanaWeb3.PublicKey("8AbwG4Cbr9DefgeF7P9Pt9RJMA1RS1KVogRWBWh9U8wM");
var delay = process.env.REACT_APP_WALLET_ADAPTER_NETWORK == 'dev' ? 
  new solanaWeb3.PublicKey("5dSxWtuxD6reEiaAYjtp91Kp74grdJKFxa3HduqTZH9f") :
  new solanaWeb3.PublicKey("AELNdmahtdZwtBY8sonDxgZB3oDKvjzGrvqv4xt7qHiU");
var USDC_MINT = new solanaWeb3.PublicKey("AKEWE7Bgh87GPp171b4cJPSSZfmZwQ3KaqYqXoKLNAEE")
var blankPubkey = "11111111111111111111111111111111";

// TODO: Get rid of makeStyles()
const useStyles = makeStyles((theme) => ({
  root: {},
  box: {
    // display: 'inline-block',
    display: 'flex',
    alignItems: 'center',
  },
  // Add "Button" styles for Material UI names 'primary', 'secondary', 'warning', and so on
  ...buttonStylesByNames(theme),
}));

function formatEventStart(dateNum){
  if(dateNum == -1){
    return "Event has started";
  }
  var startDate = new Date(dateNum * 1000);
  var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var month = months[startDate.getMonth()];
  var day = startDate.getDate();
  var hours = startDate.getHours().toString().padStart(2, '0');
  var minutes = startDate.getMinutes().toString().padStart(2, '0');
  var time = hours + ":" + minutes;
  return month + " " + day + " " + time;
}

/**
 * Application styled Material UI Button with Box around to specify margins using props
 * @component AppSport
 * @param {node} [children] - content to render, overrides .label and .text
 * @param {string} [logo] - name of color from Material UI palette 'primary', 'secondary', 'warning', and so on
 * @param {string} [label] - text to render, alternate to .text
 * @param {string} [text] - text to render, alternate to .label
 */
const AppPendingBet = ({
  children,
  className,
  item,
  logo = 'default',
  label, // Alternate to .text prop
  m = 0, // Box margin
  mt = APP_SPORT_MARGIN, // Box margin
  mb = APP_SPORT_MARGIN, // Box margin
  ml = 0, // Box margin
  mr = 0, // Box margin
  text, // Alternate to .label prop
  variant = APP_BUTTON_VARIANT,
  underline = 'none', // override MUI default value
  ...restOfProps
}) => {
  const classes = useStyles();
  const [state, dispatch] = useAppStore();
  const wallet = useWallet();
  const { connection } = useConnection();
  const [loading, setLoading] = useState();
  const [canCancelBet, setCanCancelBet] = useState(false);
  const { removeBet, refreshData: refreshPendingBetsData } = usePendingBetsContext();

  async function cancelBet(betAccStr) {
    let callForATA = await connection.getTokenAccountsByOwner(wallet.publicKey, { mint: mint });
    let destination = callForATA.value[0].pubkey;

    let keyform = new solanaWeb3.PublicKey(betAccStr);
    let info = await connection.getAccountInfo(keyform);
    
    let betData = Array.from(info.data);
    let id = betData.slice(0, 20);
    let side = new solanaWeb3.PublicKey(betData.slice(36, 68)).toBase58() != blankPubkey ? 0 : 1;
    let instrData = id.concat([side]);
    instrData.push(0);
    let payer = new solanaWeb3.PublicKey(betData.slice(100, 132));

    let keysArr = [
        {pubkey: keyform, isSigner: false, isWritable: true },
        {pubkey: tokenProgram, isSigner: false, isWritable: false},
        {pubkey: USDC_MINT, isSigner: false, isWritable: false},
        {pubkey: pool, isSigner: false, isWritable: true },
        {pubkey: destination, isSigner: false, isWritable: true},
        {pubkey: wallet.publicKey, isSigner: true, isWritable: true },
        {pubkey: payer, isSigner: false, isWritable: true },
        {pubkey: pda, isSigner: false, isWritable: true }
    ];
    if(betData[141] == 1){// to aggregate
        keysArr.push({pubkey: delay, isSigner: false, isWritable: false});
    }
    // console.log(keysArr, instrData)
    let betInstr = new solanaWeb3.TransactionInstruction({
        keys: keysArr,
        programId: programID,
        data: new Uint8Array(instrData),
    });
    let transaction = new solanaWeb3.Transaction();
    transaction.add(betInstr);
    transaction.feePayer = wallet.publicKey;
    let blockInfo = await connection.getLatestBlockhash(); 
    transaction.recentBlockhash = blockInfo.blockhash;

    const {
      context: { slot: minContextSlot },
      value: { blockhash, lastValidBlockHeight },
    } = await connection.getLatestBlockhashAndContext();

    const signature = await wallet.sendTransaction(transaction, connection, { minContextSlot });
    console.log("cancel sig", signature)
    await connection.confirmTransaction({ signature });
    //now make an API call to mark the bet as canceled in betlog
    await axios.get("https://p43l0w1hu4.execute-api.ap-northeast-1.amazonaws.com/default/pendingBetsV2?cancel=" + betAccStr + "&for=" + wallet.publicKey.toBase58());
    return signature;
  }

  const handleBetCancel = () => {
    setLoading(true);
    cancelBet(item.betAddr)
      .then((result) => {
        console.log('Bet cancel: ', result);
        if(result != "too early"){
          removeBet(item.betAddr);
        }
        //refreshPendingBetsData();
      })
      .finally(() => setLoading(false));
  };

  const checkCancellableAction = () => {
    //console.log(item);
    if (isPast(add(fromUnixTime(item.placedAt), { seconds: 180 }))) {
      setCanCancelBet(true);
    }
  };

  useEffect(() => {
    // console.log("here is a bet", item)
    if (item?.placedAt) {
      //console.log(item);
      if (isPast(add(fromUnixTime(item?.placedAt), { seconds: 180 }))) {
        setCanCancelBet(true);
      } else {
        setTimeout(() => {
          checkCancellableAction();
        }, differenceInSeconds(add(fromUnixTime(item?.placedAt), { seconds: 180 }), fromUnixTime(item?.placedAt)) * 1000);
      }
    }
  }, [item?.placedAt]);

  item.isLay = (item.mkt == 1 || item.mkt == 2 || item.mkt == 3) && item.bettorSide == 1

  return (
    <>
      {item && (
        <Box
          {...{ m, mt, mb, ml, mr }}
          sx={{
            display: 'flex',
            boxShadow: 1,
            borderRadius: '8px',
            color: item.isMatched ? 'black' : 'white',
          }}
        >
          <Box
            component="span"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              writingMode: 'vertical-rl',
              textOrientation: 'upright',
              backgroundColor: item.isLay ? '#e52037' : '#4b8951',
              minWidth: 30,
              borderRadius: '8px 0 0 8px',
              color: 'white',
            }}
          >
            {item.isLay ? 'LAY' : 'BACK'}
          </Box>
          <Box
            component="div"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              backgroundColor: item.isMatched ? 'white' : '#f96a6a',
              paddingLeft: 2,
              paddingRight: 0,
              paddingTop: 0.5,
              paddingBottom: 0.5,
              borderRadius: item.isMatched ? '0 8px 8px 0' : 0,
            }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Box component="span" sx={{ color: 'black', marginRight: 1 }}>
                Status:{' '}
              </Box>
              <Box component="span" sx={{ color: item.isMatched ? 'green' : '#FB0F00', fontWeight: 'bold', flexGrow: 1}}>
                {item.isMatched ? 'MATCHED' : 'UNMATCHED'}
              </Box>

              <Box component="span" sx={{marginRight: 1.5}}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <img src="/img/tokens/eclipse.png" width="14" style={{ marginRight: '4px' }} />
                  <Link color="#000" underline="none" sx={{ fontSize: '0.7rem' }} href={"https://eclipsescan.xyz/address/" + item.betAddr + (process.env.REACT_APP_WALLET_ADAPTER_NETWORK == 'dev' ? '?cluster=devnet' : '')}   target="_blank"> { item.betAddr.substring(0, 5) + '..' } </Link>
                </div>
              </Box>
            </Box>

            <Box
              component="span"
              sx={{
                marginTop: 0.5,
                fontWeight: 'bold',
                fontSize: '1.2rem',
              }}
            >
              {item.description}
            </Box>
            <Box
              component="span"
              sx={{
                color: 'rgba(0, 0, 0, 0.5)',
                fontSize: '0.8rem',
              }}
            >
              {/* 1&times;2 - {item.team} */}
              {item.event}
            </Box>
            <Box
              component="span"
              sx={{
                color: 'rgba(0, 0, 0, 0.5)',
                fontSize: '0.8rem',
              }}
            >
              {/* 1&times;2 - {item.team} */}
              {formatEventStart(item.eventStart)}
            </Box>
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  marginTop: 0.5,
                  fontSize: '0.8rem',
                }}
              >
                <Box component="div">
                  <Box component="span" sx={{ color: '#292929', marginRight: 0.5 }}>
                    {!item.isLay
                      ? 'Stake'
                      : !state.layBetSlipStyle
                      ? 'Risk'
                      : "Backer's stake"}{''}
                    :{''}
                  </Box>
                  <Box component="span" sx={{ marginRight: 1 }}>
                    {item.isMatched
                      ? item.isLay
                        ? !state.layBetSlipStyle
                          ? item.bettorStake
                          : Math.round((item.bettorStake / (item.bettorOdds - 1)) * 100) / 100
                        : item.bettorStake
                      : '0.00/' +
                        (item.isLay
                          ? !state.layBetSlipStyle
                            ? item.bettorStake
                            : Math.round((item.bettorStake / (item.bettorOdds - 1)) * 100) / 100
                          : item.bettorStake)}{' '}
                    USDC
                  </Box>
                  <Box component="span" sx={{ color: '#292929', marginRight: 0.5 }}>
                    Odds:{''}
                  </Box>
                  <Box component="span">
                    {state.oddsStyle ? item.bettorOdds : decimalToAmerican(item.bettorOdds)}
                  </Box>
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: 0.5,
                    fontSize: '0.8rem',
                  }}
                >
                  <Box component="span" sx={{ color: '#292929', marginRight: 0.5 }}>
                    Potential return:{''}
                  </Box>
                  <Box component="span">{Math.round(item.bettorStake * item.bettorOdds * 100)/100} USDC</Box>
                </Box>
              </Box>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  marginTop: 0.5,
                  fontSize: '0.8rem',
                }}
              >
                <img src="/img/logo_light.png" width="65" style={{ marginRight: '0px' }} />
              </Box>
            </Box>
          </Box>
          {!item.isMatched && (
            <Box
              component="span"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#b11a10',
                minWidth: 30,
                borderRadius: '0 8px 8px 0',
                cursor: canCancelBet ? 'pointer' : 'default',
                color: canCancelBet ? 'white' : 'grey',
                pointerEvents: canCancelBet ? 'auto' : 'none',
              }}
              onClick={() => canCancelBet && handleBetCancel()}
            >
              {loading ? <CircularProgress size="1.5rem" /> : <CloseIcon />}
            </Box>
          )}
        </Box>
      )}
    </>
  );
};

AppPendingBet.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  logo: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  text: PropTypes.string,
  variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
  onClick: PropTypes.func,
};

export default AppPendingBet;
